<template>
  <div class="blogDetail__Contact container">
    <div class="blogDetail__ContactTitle" v-if="data.title">
      <p>{{ $t('location.locationAndHours') }}</p>
      <h2>{{ data.title }}</h2>
    </div>
    <div class="blogDetail__ContactContent">
      <div class="blogDetail__ContactContentItem" v-if="data.email">
        <h3>{{ $t('location.email') }}</h3>
        <div class="blogDetail__ContactContentItemText">
          <p>{{ data.email }}</p>
        </div>
      </div>
      <div class="blogDetail__ContactContentItem" v-if="data.location">
        <h3>{{ $t('location.location') }}</h3>
        <div class="blogDetail__ContactContentItemText" v-html="data.location"></div>
      </div>
      <div class="blogDetail__ContactContentItem" v-if="data.contact">
        <h3>{{ $t('location.contact') }}</h3>
        <div class="blogDetail__ContactContentItemText" v-html="data.contact"></div>
      </div>
      <div class="blogDetail__ContactContentItem" v-if="data.working_hours">
        <h3>{{ $t('location.workingHours') }}</h3>
        <div class="blogDetail__ContactContentItemText" v-html="data.working_hours"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
  defineOptions({
    autoImportStyles: false
  });
  
  const props = defineProps({
    data: {}
  })
</script>